import React from 'react';
import '../CheckinInfo.css';
import {DesktopTimePicker} from '@mui/x-date-pickers';
import Select from 'react-select';
import AddCheckinInfoGraph from './AddCheckinInfoGraph';
import './AddCheckinInfo.sass';
import './AddCheckinInfo.css';
import {MDBCheckbox} from 'mdb-react-ui-kit';

/**
 * Vue qui permet d'ajouter un checkin
 * @param {*} props props
 * @return {JSX}
 */
function AddCheckinInfoView(props) {
  return (
    <form className="form" onSubmit={props.handleSubmit}>
      <span className="employe-close" onClick={() => props.back()} style={{marginRight: '10px'}}>
                &times;
      </span>
      <h3 style={{color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Ajouter un checkin</h3>
      <div className="app" style={{textAlign: 'center'}}>

        {localStorage.getItem('admin') === '1' ?
        <div className="form-group" style={{textAlign: 'left', marginBottom: '15px'}}>
          <label className="addcheckin-labelchantier">Employés du checkin</label>
          <Select
            className="form-control addcheckin-form-control-padding"
            name="employer"
            value={props.employerCheckinId}
            onChange={props.checkinEmployeChange}
            options={props.usernames}
            placeholder="Employés du checkin"
            styles={{
              placeholder: (provided) => ({
                ...provided,
                fontSize: '18px',
                fontWeight: '450',
                color: 'black',
              }),
              control: (provided) => ({
                ...provided,
                minHeight: '5px',
                height: 'auto',
              }),
            }}>
          </Select>
        </div> : ''}

        <label className="addcheckin-labelchantier">Voir tout les projets?</label>
        <div className="toggle-switch">
          <div>
            <input
              id="toggle"
              type="checkbox"
              checked={props.checkedChantier}
              onChange={props.handleChantierCheckBox} />
            <label htmlFor="toggle"></label>
          </div>
        </div>
      </div>
      <div style={{marginTop: '18px'}}>
        <Select
          name="Chantiers"
          options={props.placeName}
          onChange={ (e) => props.handleChange(e, 'chantier')}
          className="form-control addcheckin-form-control-padding"
          placeholder="Projets"
          styles={{
            placeholder: (provided) => ({
              ...provided,
              fontSize: '18px',
              fontWeight: '450',
              color: 'black',
            }),
            control: (provided) => ({
              ...provided,
              minHeight: '5px',
              height: 'auto',
            }),
          }} />
      </div>
      {props.form.errorsForm && props.form.errorsForm.chantier && (
        <span className="error">{props.form.errorsForm.chantier}</span>
      )}
      <div className="form-group">
        <input
          className="form-control"
          type="date"
          value={props.form.date}
          onChange={props.handleDateChange}
          style={{fontSize: '18px', color: 'black', fontWeight: '450'}} />
      </div>
      {props.form.errorsForm && props.form.errorsForm.date && (
        <span className="error">{props.form.errorsForm.date}</span>
      )}
      <div className="form-group">
        <Select
          className="form-control addcheckin-form-control-padding"
          isMulti
          value={props.form.employer}
          onChange={ (e) => props.handleChange(e, 'employer')}
          options={props.usernames}
          placeholder="Travaillé avec ?"
          styles={{
            placeholder: (provided) => ({
              ...provided,
              fontSize: '18px',
              fontWeight: '450',
              color: 'black', // Adjust the font size as desired
            }),
            control: (provided) => ({
              ...provided,
              minHeight: '5px', // Adjust the minimum height as desired
              height: 'auto',
            }),
          }}>
        </Select>
      </div>
      <div className="app" style={{textAlign: 'center', marginTop: '17px'}}>
        <label className="addcheckin-labeltransport">Transport?</label>
        <div className="toggle-switch">
          <div>
            <input
              id="toggleTransport"
              type="checkbox"
              name="transport"
              checked={props.form.transport}
              onChange={props.handleChangeCheckBox} />
            <label htmlFor="toggleTransport"></label>
          </div>
        </div>
      </div>
      <div style={{color: 'white', marginTop: '18px'}}>
        <MDBCheckbox name='extra1' id='inlineCheckbox111' value='option1' label='Extra possible' onChange={props.handleChangeCheckBox} inline />
        {localStorage.getItem('admin') === '1' ?
        <React.Fragment>
          <MDBCheckbox name='extra2' id='inlineCheckbox222' value='option2' label='Extra valider' onChange={props.handleChangeCheckBox} inline />
          <MDBCheckbox name='extra3' id='inlineCheckbox333' value='option3' label='Extra confirmer' onChange={props.handleChangeCheckBox} inline />
        </React.Fragment> : ''}

      </div>
      <div className="form-group">
        <textarea
          className="form-control"
          value={props.form.note == null ? '' : props.form.note}
          onChange={props.handleNoteChange}
          placeholder="Note" />
      </div>
      <div className="form-group">
        <div className="form-group-inline form-group-inline-label">
          <div className="form-group-inline-item">
            <DesktopTimePicker
              label="Check-in"
              value={props.form.checkin}
              onChange={ (e) => props.handleChange(e, 'checkin')}
              ampm={false}
              sx={{
                'width': 220,
                '& input': {color: 'white'},
                '& label': {color: 'white', fontSize: '20px'},
                '& button': {color: 'white', fontSize: '25px'},
              }} />
          </div>
          <div className="form-group-inline-item">
            <DesktopTimePicker
              label="Check-out"
              value={props.form.checkout}
              onChange={ (e) => props.handleChange(e, 'checkout')}
              ampm={false}
              sx={{
                'width': 220,
                '& input': {color: 'white'},
                '& label': {color: 'white', fontSize: '20px'},
                '& button': {color: 'white', fontSize: '25px'},
              }} />
          </div>
        </div>
      </div>
      {props.form.errorsForm && props.form.errorsForm.heure && (
        <span className="error">{props.form.errorsForm.heure}</span>
      )}
      {props.form.checkin !== null && props.form.checkout !== null && props.form.checkin < props.form.checkout?
      <AddCheckinInfoGraph startend={props.startend} taches={props.taches} setTaches={props.setTaches} nbHeures={props.nbHeures}/> : ''}
      <button type="submit" className="btn btn-primary" style={{marginTop: '10px', backgroundColor: '#0d6efd', color: 'white'}}>
      Enregistrer
      </button>
    </form>
  );
}

export default AddCheckinInfoView;
